import { render } from "./Home.vue?vue&type=template&id=1816b9a8&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=1816b9a8&scoped=true&lang=less"

import exportComponent from "/Users/dinghuaiqiang/gitee/lavenir-reed-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1816b9a8"]])

export default __exports__